import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgStarFill = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m25.625 12.562-4.921 4.247 1.5 6.351a1.794 1.794 0 0 1-2.68 1.95L14 21.71l-5.527 3.4a1.794 1.794 0 0 1-2.676-1.95l1.505-6.351-4.922-4.247A1.8 1.8 0 0 1 3.4 9.406l6.452-.52 2.49-6.025a1.789 1.789 0 0 1 3.31 0l2.489 6.025 6.453.52a1.8 1.8 0 0 1 1.025 3.157l.006-.001Z" />
  </svg>
);
export default SvgStarFill;
